/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { PathologyBaseService } from '../pathology-base-service';
import { PathologyApiConfiguration } from '../pathology-api-configuration';
import { PathologyStrictHttpResponse } from '../pathology-strict-http-response';

import { FormStatus } from '../models/form-status';
import { InsuranceFormDataModel } from '../models/insurance-form-data-model';
import { InsuranceGridResultDataModelSearchResultModel } from '../models/insurance-grid-result-data-model-search-result-model';
import { insuranceIdDelete } from '../fn/insurance/insurance-id-delete';
import { InsuranceIdDelete$Params } from '../fn/insurance/insurance-id-delete';
import { insuranceIdGet } from '../fn/insurance/insurance-id-get';
import { InsuranceIdGet$Params } from '../fn/insurance/insurance-id-get';
import { insuranceIdGetStatusGet } from '../fn/insurance/insurance-id-get-status-get';
import { InsuranceIdGetStatusGet$Params } from '../fn/insurance/insurance-id-get-status-get';
import { insuranceIdSetStatusPost } from '../fn/insurance/insurance-id-set-status-post';
import { InsuranceIdSetStatusPost$Params } from '../fn/insurance/insurance-id-set-status-post';
import { insurancePost } from '../fn/insurance/insurance-post';
import { InsurancePost$Params } from '../fn/insurance/insurance-post';
import { insuranceSearchFormPost } from '../fn/insurance/insurance-search-form-post';
import { InsuranceSearchFormPost$Params } from '../fn/insurance/insurance-search-form-post';

@Injectable({ providedIn: 'root' })
export class PATHInsuranceService extends PathologyBaseService {
  constructor(config: PathologyApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `insuranceSearchFormPost()` */
  static readonly InsuranceSearchFormPostPath = '/Insurance/SearchForm';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `insuranceSearchFormPost()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  insuranceSearchFormPost$Response(params?: InsuranceSearchFormPost$Params, context?: HttpContext): Observable<PathologyStrictHttpResponse<InsuranceGridResultDataModelSearchResultModel>> {
    return insuranceSearchFormPost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `insuranceSearchFormPost$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  insuranceSearchFormPost(params?: InsuranceSearchFormPost$Params, context?: HttpContext): Observable<InsuranceGridResultDataModelSearchResultModel> {
    return this.insuranceSearchFormPost$Response(params, context).pipe(
      map((r: PathologyStrictHttpResponse<InsuranceGridResultDataModelSearchResultModel>): InsuranceGridResultDataModelSearchResultModel => r.body)
    );
  }

  /** Path part for operation `insuranceIdGet()` */
  static readonly InsuranceIdGetPath = '/Insurance/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `insuranceIdGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  insuranceIdGet$Response(params: InsuranceIdGet$Params, context?: HttpContext): Observable<PathologyStrictHttpResponse<InsuranceFormDataModel>> {
    return insuranceIdGet(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `insuranceIdGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  insuranceIdGet(params: InsuranceIdGet$Params, context?: HttpContext): Observable<InsuranceFormDataModel> {
    return this.insuranceIdGet$Response(params, context).pipe(
      map((r: PathologyStrictHttpResponse<InsuranceFormDataModel>): InsuranceFormDataModel => r.body)
    );
  }

  /** Path part for operation `insuranceIdDelete()` */
  static readonly InsuranceIdDeletePath = '/Insurance/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `insuranceIdDelete()` instead.
   *
   * This method doesn't expect any request body.
   */
  insuranceIdDelete$Response(params: InsuranceIdDelete$Params, context?: HttpContext): Observable<PathologyStrictHttpResponse<void>> {
    return insuranceIdDelete(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `insuranceIdDelete$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  insuranceIdDelete(params: InsuranceIdDelete$Params, context?: HttpContext): Observable<void> {
    return this.insuranceIdDelete$Response(params, context).pipe(
      map((r: PathologyStrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `insurancePost()` */
  static readonly InsurancePostPath = '/Insurance';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `insurancePost()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  insurancePost$Response(params?: InsurancePost$Params, context?: HttpContext): Observable<PathologyStrictHttpResponse<void>> {
    return insurancePost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `insurancePost$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  insurancePost(params?: InsurancePost$Params, context?: HttpContext): Observable<void> {
    return this.insurancePost$Response(params, context).pipe(
      map((r: PathologyStrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `insuranceIdSetStatusPost()` */
  static readonly InsuranceIdSetStatusPostPath = '/Insurance/{id}/SetStatus';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `insuranceIdSetStatusPost()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  insuranceIdSetStatusPost$Response(params: InsuranceIdSetStatusPost$Params, context?: HttpContext): Observable<PathologyStrictHttpResponse<void>> {
    return insuranceIdSetStatusPost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `insuranceIdSetStatusPost$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  insuranceIdSetStatusPost(params: InsuranceIdSetStatusPost$Params, context?: HttpContext): Observable<void> {
    return this.insuranceIdSetStatusPost$Response(params, context).pipe(
      map((r: PathologyStrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `insuranceIdGetStatusGet()` */
  static readonly InsuranceIdGetStatusGetPath = '/Insurance/{id}/GetStatus';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `insuranceIdGetStatusGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  insuranceIdGetStatusGet$Response(params: InsuranceIdGetStatusGet$Params, context?: HttpContext): Observable<PathologyStrictHttpResponse<FormStatus | null>> {
    return insuranceIdGetStatusGet(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `insuranceIdGetStatusGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  insuranceIdGetStatusGet(params: InsuranceIdGetStatusGet$Params, context?: HttpContext): Observable<FormStatus | null> {
    return this.insuranceIdGetStatusGet$Response(params, context).pipe(
      map((r: PathologyStrictHttpResponse<FormStatus | null>): FormStatus | null => r.body)
    );
  }

}
